import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=284d3e7a&scoped=true"
import script from "./serviceList.vue?vue&type=script&lang=js"
export * from "./serviceList.vue?vue&type=script&lang=js"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=284d3e7a&prod&scoped=true&lang=css"
import style1 from "./serviceList.vue?vue&type=style&index=1&id=284d3e7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284d3e7a",
  null
  
)

export default component.exports